import axios from 'axios';
import Qs from 'qs';
// 引入状态管理 - rbac权限判断
import commons from '../util/commons';
// 主接口
const mianApi = axios.create({});
const generalApi = axios.create({});
// 请求前
mianApi.interceptors.request.use((config) => {
  const conInfo = config;
  // 根地址
  conInfo.baseURL = process.env.BASE_URL;
  // 超时时间
  conInfo.timeout = 30000;
  // Authorization 配置 模拟登录token
  const localUser = commons.readTodos('localUser');
  if(localUser !== null){
    conInfo.headers.Authorization = localUser.token;
  }else{
    conInfo.headers.Authorization = '';
  }
  conInfo.headers['Content-Type'] = 'application/x-www-form-urlencoded';
  // 返回配置信息
  return conInfo;
});
// 请求后
mianApi.interceptors.response.use(config => config);
/**
* get方法，对应get请求
* @param {String} url [请求的url地址]
* @param {Object} params [请求时携带的参数]
*/
const mianApiGet = function get(url, params, type = 'mianApi') {
  return new Promise((resolve, reject) => {
    if (type === 'mianApi') {
      mianApi.get(url, params).then((res) => {
        resolve(res.data);
      }).catch((err) => {
        reject(err.data);
      });
    } else {
      generalApi.get(url, { params }).then((res) => {
        resolve(res.data);
      }).catch((err) => {
        reject(err.data);
      });
    }
  });
};
/**
* post方法，对应post请求
* @param {String} url [请求的url地址]
* @param {Object} params [请求时携带的参数]
*/
const mianApiPost = function post(url, params, type = 'mianApi') {
  params = Qs.stringify(params);
  return new Promise((resolve, reject) => {
    if (type === 'mianApi') {
      mianApi.post(url, params).then((res) => {
        resolve(res.data);
      }).catch((err) => {
        reject(err.data);
      });
    } else {
      generalApi.post(url, params).then((res) => {
        resolve(res.data);
      }).catch((err) => {
        reject(err.data);
      });
    }
  });
};
// 抛出函数
export { mianApiGet, mianApiPost };



// WEBPACK FOOTER //
// ./src/request/http.js